import React from "react";
function GetHTML(pid,
    name,
    referrer,
    age,
    gender,
    body_parts,
    birth_date,
    upload_date,
    report_date,
    report,
    isPdf,
    image) {
        var ageKey='';
        var ageParam='';
        if(age === '0' && birth_date)
        {
            ageKey = 'Date of Birth';
            ageParam = `${birth_date.substring(0,4)}-${birth_date.substring(4,6)}-${birth_date.substring(6,8)}`;
        }
        else {
            ageKey='Age';
            ageParam=age;
        }

    const html = `
    <html>
    <body style="margin-left: 5%;margin-right: 5%;">
    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
    <table align="center" style="font-family: Tahoma, Arial, Helvetica, sans-serif; float:left; width:100%; height:auto; margin:0; border-collapse: collapse; padding:0;" >
    <tbody>
    <tr>
    <td style="width:50%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Patient ID: <strong>${pid}</strong></td>
    <td style="width:50%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Nature of X-Ray: <strong>${body_parts}</strong></td>
    </tr>
    <tr>
    <td style="width:50%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Name: <strong>${name}</strong></td>
    <td style="width:50%; border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Xray Time: <strong>${
      upload_date &&
      upload_date.substring(0, 4) +
        "." +
        upload_date.substring(4, 6) +
        "." +
        upload_date.substring(6, 8) +
        " " +
        upload_date.substring(8, 10) +
        ":" +
        upload_date.substring(10, 12)
    }</strong></td>
        </tr>
               <tr>
        <td style="width:50%;border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">${ageKey}: <strong>${ageParam}</strong></td>
      <td style="width:50%;border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Reporting Time: <strong>${
        report_date &&
        report_date.substring(0, 4) +
          "." +
          report_date.substring(4, 6) +
          "." +
          report_date.substring(6, 8) +
          " " +
          report_date.substring(8, 10) +
          ":" +
          report_date.substring(10, 12)
      }</strong></td>
        </tr>
        <tr><td style="width:50%;border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Gender: <strong>${gender}</strong></td>
        <td style="width:50%;border: 1px solid black; color: #000; font-size: 12px; line-height: 1; padding: 0 1%; position: relative; vertical-align: middle;">Ref. By: <strong>${referrer}</strong></td>
        </tr>
        </tbody>
        </table>
        ${report}
    <table align="center" style=" font-size:11px; width:90%; height: auto; border-collapse: collapse; "> <!--4 no table-->
    <tr>
      <td align="right" style="font-family: Tahoma, Arial, Helvetica, sans-serif; float:right; padding-top:5px; padding-bottom:0px;color:#333; font-size: 11px;">

    <img src="${image}" alt="signature" width="170" height="115" />
     <br/>
      </td>
    </tr>

    </table>
        </body>
        </html>`;
    return html;
}
export default GetHTML;